<template>
  <v-dialog
    :value="coordinatesDialog"
    content-class="request-field-item-dialog"
    persistent
    width="400"
  >
    <v-card color="#f0f0ef" class="home-form-container" style="height: 180px">
      <v-card-text
        class="home-form-container"
        style="text-align: left; padding: 3px 0 0 0; overflow: visible"
      >
        <input-field
          :label="$t('Latitude')"
          v-model="coordinates.latitude"
          input-type="float"
          :required="true"
          size="100"
        />
        <input-field
          :label="$t('Longitude')"
          v-model="coordinates.longitude"
          input-type="float"
          :required="true"
          size="100"
        />
      </v-card-text>

      <v-card-actions style="padding: 10px 20px 0 0">
        <v-spacer />
        <management-button
          type="cancel"
          :label="$t('Cancel')"
          @buttonClick="closeCoordinatesDialog"
        />
        <management-button
          type="execute"
          :label="$t('Center')"
          :disabled="!validCoordinates"
          @buttonClick="centerOnCoordinates"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ManagementButton from "@/components/Management/ManagementButton";
import InputField from "@/components/Home/Forms/_Molecules/InputField";

export default {
  name: "WorkspaceCoordinates",

  components: {
    ManagementButton,
    InputField
  },

  props: {
    coordinatesDialog: {
      type: Boolean
    },

    coordinates: {
      type: Object
    }
  },

  computed: {
    validLatitude() {
      if (this.coordinates.latitude) {
        return (
          this.coordinates.latitude >= -90 && this.coordinates.latitude <= 90
        );
      } else {
        return false;
      }
    },

    validLongitude() {
      if (this.coordinates.longitude) {
        return (
          this.coordinates.longitude >= -180 &&
          this.coordinates.longitude <= 180
        );
      } else {
        return false;
      }
    },

    validCoordinates() {
      return this.validLatitude && this.validLongitude;
    }
  },

  methods: {
    closeCoordinatesDialog() {
      this.$emit("close-coordinates-dialog");
    },

    centerOnCoordinates() {
      this.$emit("center-on-coordinates");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProjectManagement/Workspaces/WorkspaceCoordinates.vue